import { NavLink } from 'react-router-dom';
import { HStack, Flex, Box, Center, Text } from '@chakra-ui/react';
import { CustomNavArrowIcon } from '../theme/icons/CustomNavArrowIcon';

const CustomNavlink = (props) => {
  const inner = (
    <Flex alignItems="center" justifyContent="space-between">
      <HStack spacing={3} w="full" alignContent="center">
        <Box w="40px" h="30px" justifyContent="center">
          <Center h="full">
            <props.component
              height={props.height ? props.height : '30px'}
              className="sideNavIcon"
              data-testid="sideNavIcon"
            />
          </Center>
        </Box>
        <Box fontSize="14px" fontFamily="Inter SemiBold">
          {props.title}
          {props.rightIcon && (
            <CustomNavArrowIcon boxSize={2.5} ml={1} className="sideNavIcon" />
          )}
          {props.subtitle && (
            <Text textStyle="bodyFamilyRegular" fontSize="10px" maxW="120px">
              {props.subtitle}
            </Text>
          )}
        </Box>
      </HStack>
    </Flex>
  );

  if (props.externalHref) {
    return (
      <a
        href={props.externalHref}
        target="_blank"
        rel="noopener noreferrer"
        className={props.className ?? 'inactive'}
        onClick={props.onClick}
      >
        {inner}
      </a>
    );
  }

  return (
    <NavLink
      to={props.to}
      className={({ isActive }) =>
        isActive ? (props.className ? props.className : 'active') : 'inactive'
      }
      onClick={props.onClick}
    >
      {inner}
    </NavLink>
  );
};

export default CustomNavlink;
